import { useEffect, useState } from 'react'

import { getTimeRemaining } from '../utils/datetime'

const useCountdown = ({ deadline }) => {
  const [label, setLabel] = useState(getTimeRemaining(deadline))

  useEffect(() => {
    const interval = setInterval(() => {
      const timeRemaining = getTimeRemaining(deadline)

      if (!timeRemaining) {
        clearInterval(interval)
      }

      setLabel(getTimeRemaining(deadline))
    }, 500)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return label
}

export default useCountdown
